<n-slide-window *ngIf="pageReady" [visible]="windowVisible" width="7rem" (onHide)="close()">
    <n-header>
        <h1>{{i18n.title.modifyMappingRule}}</h1>
        <n-help-link key="cifshomedirModifyMap"></n-help-link>
    </n-header>

    <form [errorMessage]="errorMessage" [formGroup]="vm" class="common-form">
        <!-- 所属租户 -->
        <n-form-item [label]="i18n.label.vStoreLab">
            <div id="create-homedir-rule-cifs-share-vstore" class="n-form-item-text">{{vstoreName || UNPLACEHOLDER}}</div>
        </n-form-item>
        <!-- 用户名 -->
        <n-form-item
            [label]="i18n.label.userName">
            <div id="modify-homedir-rule-cifs-share-username" class="n-form-item-text">{{data.NAME || this.UNPLACEHOLDER}}</div>
        </n-form-item>
        <!-- 共享路径，只展示 -->
        <n-form-item [required]="false" [label]="i18n.label.share_path">
            <div id="modify-homedir-rule-cifs-share-share_path" class="n-form-item-text text-wrap">{{data.fsPath || this.UNPLACEHOLDER}}</div>
        </n-form-item>

        <!-- 优先级 -->
        <n-form-item [label]="i18n.label.priority"
            [helpContent]="i18n.tip.priority"
            [required]="true">
            <n-spinner id="create-homedir-rule-cifs-share-priority"
                [min]="1" [onlyInput]="true" [rangeTip]="true"
                [max]="1024" formControlName="priority">
            </n-spinner>
        </n-form-item>
        <!-- autoCreate 自动创建 -->
        <n-form-item [label]="i18n.label.autoCreate"
            [helpContent]="i18n.tip.autoCreate">
            <n-checkbox id="create-homedir-rule-cifs-share-autoCreate"
                style="margin-left: auto;"
                [label]="i18n.label.enable"
                formControlName="autoCreate">
            </n-checkbox>
        </n-form-item>
    </form>

    <n-footer>
        <button id="modify-homedir-rule-cifs-share-ok-btn" nButton theme="primary" [label]="i18n.btn.okBtn" (click)="onOk()">
        </button>
        <button id="modify-homedir-rule-cifs-share-cancel-btn" nButton [label]="i18n.btn.cancelBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
